export default class BrandDomainService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('me/brand/domains', params)
	}

	createEntity(params){
		return this.apiService.callPost('me/brand/domains', params);
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/brand/domains/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/brand/domains/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/BrandDomainService.js